module.exports = __webpack_public_path__ + "static/media/no_image.a04d849c.jpg";